// 使用例(input): <input v-z-currency:input="boolean" /> : 表示例 '1,000,000'
// 例(td): <td v-z-currency:td="boolean"></td> : 表示例 '1,000,000'
// 例(td_yen): <td v-z-currency:td_yen="boolean"></td> : 表示例 '¥1,000,000'

// 数文字であるかのチェック（カンマは除去）
const isNumeric = (val) => {
  const v = val.replace(',', '');
  return /^-?\d+(\.\d+$|$)/.test(v);
};

// 通貨形式に変換する
const formatCurrency = (inputValue: string): string => {
  const value = inputValue.replace(/,/g, '');
  if (isNaN(parseInt(value))) return '';
  if (value.includes('.')) {
    const items = value.split('.');
    return `${parseInt(items[0]).toLocaleString()}.${items[1]||''}`;
  }
  return parseInt(value).toLocaleString();
};

// input要素の場合の処理
const inputBinding = (el: any, binding: any) => {
  if (binding.value) {
    const ret = formatCurrency(binding.value);

    // retがNaNでなければ、el.valueに代入する
    if (ret !== '') {
      el.value = formatCurrency(binding.value);
    } else {
      el.value = binding.oldValue;
    }

  }
};

// td要素の場合の処理
const tdBinding = (el: any, binding: any) => {
  if (binding.value && el.innerText && isNumeric(el.innerText)) {
    const n = parseInt(el.innerText.replace(',', ''));
    if (n == 0 || n) {
      el.innerText = n.toLocaleString();
      el.style.textAlign = 'right';
    }
  }
};

// td要素の場合の処理（¥付き）
const tdYenBinding = (el: any, binding: any) => {
  if (binding.value && el.innerText && isNumeric(el.innerText)) {
    const n = parseInt(el.innerText.replace(',', ''));
    if (n == 0 || n) {
      el.innerText = `¥${n.toLocaleString()}`;
      el.style.textAlign = 'right';
    }
  }
};

// ディレクティブの処理
const procCurrency = (el: any, binding: any) => {
  switch(binding.arg) {
    case 'input': // フォームのinput要素の場合
      inputBinding(el, binding);
      break;
    case 'td': // テーブルのtd要素の場合
      tdBinding(el, binding);
      break;
    case 'td_yen': // テーブルのtd要素の場合
      tdYenBinding(el, binding);
      break;
  }
};

// ディレクティブの定義
const zettantCurrency = {
  mounted(el: any, binding: any) {
    procCurrency(el, binding);
  },
  updated(el: any, binding: any) {
    procCurrency(el, binding);
  }
};

export default zettantCurrency;